import React from 'react'
import { ThemeProvider } from 'styled-components/macro'
import { Router } from '@reach/router'

import theme from './styles/theme'
import demoTheme from './styles/demoTheme'
import Home from './routes/Home/Home'
import Survey from './routes/Survey/Survey'
import Recommendations from './routes/Recommendations/Recommendations'
import Screener from './routes/Screener/Screener'
import NotFound from './routes/NotFound/NotFound'

const routesData = [
  {
    path: '/',
    voucher: false
  },
  {
    path: '/voucher',
    voucher: true
  },
  {
    path: '/demo',
    demo: true,
    voucher: true
  }
]

// GEL example
// const StyledCustomPageHeaderContainer = styled.div`
//       background-color: ${pageHeaderBackgroundColor};
//       padding: ${getGelTokens().global.sizeBaseX4}px ${
//   getGelTokens().global.sizeBaseX6
// }px;
//       display: flex;
//       justify-content: space-between;
//       align-items: center;

//     @media(min-width: ${getGelTokens().global.breakpointXSmall}px) {
//          padding: ${getGelTokens().global.sizeBaseX2}px ${
//   getGelTokens().global.sizeBaseX4
// }px;
//     }
//  `

// TODO convert to estyled or remove estyled (use style prop)?

const RouteWrapper = ({ children }) => <div>{children}</div>

const getRoutes = () => {
  return routesData.map(({ path, voucher, demo }) => {
    return (
      <RouteWrapper path={path} key={path}>
        <Home path='/' routePath={path} voucher={voucher} demo={demo} />
        <Survey path='/survey' routePath={path} voucher={voucher} demo={demo} />
        <Recommendations
          path='/recommendations'
          voucher={voucher}
          demo={demo}
        />
        <Screener path='/screener' demo={demo} />
        <NotFound default />
      </RouteWrapper>
    )
  })
}

const App = () => (
  <ThemeProvider
    theme={window.location.pathname.startsWith('/demo') ? demoTheme : theme}
  >
    <>
      <Router>{getRoutes()}</Router>
    </>
  </ThemeProvider>
)

export default App
